<template>
  <div style="text-align: center; margin-top: 8px">
    <img
      src="../../../assets/images/layout/logo-iph-hori-v1.png"
      alt="logo-iph"
      style="width: 130px"
    />
  </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>